import { TemplateType } from "../types/template";

export type SdkCredentials = {
  apiKey?: string;
  secretKey?: string;
};

export type SdkEnvConfig = {
  baseUrl?: string;
  defaultApiKey?: string;
  defaultSecretKey?: string;
  postApiKey?: string;
  postSecretKey?: string;
  verticalVideoApiKey?: string;
  verticalVideoSecretKey?: string;
  discoverApiKey?: string;
  discoverSecretKey?: string;
};

export const getSdkEnvConfig = (): SdkEnvConfig => ({
  baseUrl: process.env.REACT_APP_BASE_URL,
  defaultApiKey: process.env.REACT_APP_API_KEY,
  defaultSecretKey: process.env.REACT_APP_SECRET_KEY,
  postApiKey: process.env.REACT_APP_POST_API_KEY,
  postSecretKey: process.env.REACT_APP_POST_SECRET_KEY,
  verticalVideoApiKey: process.env.REACT_APP_VERTICAL_VIDEO_API_KEY,
  verticalVideoSecretKey: process.env.REACT_APP_VERTICAL_VIDEO_SECRET_KEY,
  discoverApiKey: process.env.REACT_APP_DISCOVER_API_KEY,
  discoverSecretKey: process.env.REACT_APP_DISCOVER_SECRET_KEY,
});

export const resolveSdkCredentials = (
  selectedTemplateType: TemplateType | null,
  envConfig: SdkEnvConfig
): SdkCredentials => {
  const defaultCredentials: SdkCredentials = {
    apiKey: envConfig.defaultApiKey,
    secretKey: envConfig.defaultSecretKey,
  };

  if (selectedTemplateType === "POST") {
    return {
      apiKey: envConfig.postApiKey || defaultCredentials.apiKey,
      secretKey: envConfig.postSecretKey || defaultCredentials.secretKey,
    };
  }

  if (selectedTemplateType === "VERTICAL_VIDEO") {
    return {
      apiKey:
        envConfig.verticalVideoApiKey || defaultCredentials.apiKey,
      secretKey:
        envConfig.verticalVideoSecretKey || defaultCredentials.secretKey,
    };
  }

  if (selectedTemplateType === "DISCOVER") {
    return {
      apiKey: envConfig.discoverApiKey || defaultCredentials.apiKey,
      secretKey: envConfig.discoverSecretKey || defaultCredentials.secretKey,
    };
  }

  return defaultCredentials;
};

export const createSdkCredentialSignature = (
  baseUrl: string | undefined,
  credentials: SdkCredentials
): string =>
  [baseUrl || "", credentials.apiKey || "", credentials.secretKey || ""].join(
    "|"
  );

const fallbackHash = (value: string) => {
  let hash = 0x811c9dc5;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash +=
      (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
  }

  return `fnv1a-${(hash >>> 0).toString(16).padStart(8, "0")}`;
};

export const createSdkCredentialFingerprint = (signature: string): string =>
  fallbackHash(signature);
